"use client"

import Link from "next/link"

import type { ComponentProps } from "react"

import { prefetchModal, type ModalName } from "./registry"
import { openUrlModal, resolveModalOpenParams } from "./url"

export function ModalLink({
  modal,
  params,
  children,
  onPointerEnter,
  onFocus,
  ...rest
}: {
  modal: ModalName
  params?: Record<string, string>
} & Omit<ComponentProps<typeof Link>, "href">) {
  const qs = new URLSearchParams({
    modal,
    ...resolveModalOpenParams(modal, params)
  })

  return (
    <Link
      {...rest}
      href={`?${qs.toString()}`}
      scroll={false}
      onPointerEnter={(event) => {
        prefetchModal(modal)
        onPointerEnter?.(event)
      }}
      onFocus={(event) => {
        prefetchModal(modal)
        onFocus?.(event)
      }}
      onClick={(event) => {
        event.preventDefault()
        openUrlModal(modal, params)
      }}
    >
      {children}
    </Link>
  )
}
